import React from 'react'
import './style.css'

export default function Footer() {
  const socials = [
    { href: "mailto:mevlydeihoxha@gmail.com", icon: "gmail-svgrepo-com.svg", label: "mevlydeihoxha@gmail.com" },
    { href: "tel:+38349393110", icon: "phone-svgrepo-com.svg", label: "+38349393110" },
    { href: "https://www.linkedin.com/in/mevlyde-hoxha/", icon: "linkedin-svgrepo-com.svg", label: "Mevlyde Hoxha" },
    { href: "https://www.instagram.com/lidahhoxha/", icon: "instagram-svgrepo-com.svg", label: "@lidahhoxha" },
    { href: "https://github.com/mevlydehoxha", icon: "github-142-svgrepo-com.svg", label: "mevlydehoxha" },
  ]

  return (
    <div className='footer'>
      <div className='top-footer'>
        <h2>lida out</h2>
      </div>

      <p>your backlog called. it wants me.</p>

      <div className='socials'>
        {socials.map((social, idx) => (
          <a
            key={idx}
            href={social.href}
            target={social.href.startsWith('http') ? "_blank" : undefined}
            rel={social.href.startsWith('http') ? "noopener noreferrer" : undefined}
            data-tooltip={social.label}
          >
            <img src={`../../assets/${social.icon}`} alt={social.label} />
          </a>
        ))}
      </div>

      <div className='border'></div>
      <div className='copyright'>
        <div>© 2026 | mevlyde hoxha</div>
        <div>thoughtfully built</div>
      </div>
    </div>
  )
}